module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "title_bar"
  }, [_c('div', {
    staticClass: "container no-padding"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'index'
      }
    }
  }, [_c('i', {
    staticClass: "title_bar-icon kp-panel-back",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title_bar-title"
  }, [_c('i', {
    staticClass: "kp-panel-report",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        " + _vm._s(_vm.$t('report.menu.report_of')) + " “" + _vm._s(_vm.boxName) + "”\n        "), _c('p', [(_vm.showBackToResume()) ? _c('router-link', {
    staticClass: "back-to-resume",
    attrs: {
      "to": {
        name: 'boxReportsResume',
        params: {
          boxId: _vm.$route.params.boxId
        }
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-back",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('report.menu.back_to_answers_summary')) + "\n          ")]) : _vm._e()], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "tab_pages"
  }, [_c('li', [_c('router-link', {
    staticClass: "tab_pages-item",
    attrs: {
      "to": {
        name: 'boxReportsMetrics',
        params: {
          locale: _vm.i18n.locale,
          boxId: _vm.$route.params.boxId
        }
      },
      "active-class": "active",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "kp-panel-metrics",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('report.menu.metrics')) + "\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "tab_pages-item",
    attrs: {
      "to": {
        name: 'boxReportsIndividuals',
        params: {
          locale: _vm.i18n.locale,
          boxId: _vm.$route.params.boxId
        }
      },
      "active-class": "active",
      "exact": ""
    }
  }, [_c('i', {
    staticClass: "kp-panel-table",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('report.menu.individual_answers')) + "\n          ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "report-box-options"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('ul', {
    staticClass: "dropdown-menu-container"
  }, [_c('li', {
    staticClass: "highlight"
  }, [_vm._v(_vm._s(_vm.$t('report.menu.box_options')))]), _vm._v(" "), _c('li', [_c('export-box', {
    attrs: {
      "box": _vm.boxActive
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "mobile-hide"
  }, [(_vm.boxActive.id) ? _c('edit-box', {
    attrs: {
      "box": _vm.boxActive
    }
  }) : _vm._e()], 1)])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container no-padding"
  }, [_c('router-view')], 1), _vm._v(" "), _c('modal-code')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "tab_pages-item"
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-h",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-318ddf36!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Report.vue
 ** module id = 793
 ** module chunks = 1
 **/